import { StoreProvider } from './StoreContext';
import { ThemeProvider } from './ThemeProvider';
import { AppRouter } from './AppRouter';
import { MotionRoot } from './MotionRoot';
import { PwaUpdatePrompt } from './PwaUpdatePrompt';
import { ToastProvider, ToastViewport } from '@/components/ui';

export function App() {
  return (
    <StoreProvider>
      <ThemeProvider>
        <MotionRoot>
          <ToastProvider>
            <AppRouter />
            <PwaUpdatePrompt />
            <ToastViewport />
          </ToastProvider>
        </MotionRoot>
      </ThemeProvider>
    </StoreProvider>
  );
}
